import { render, staticRenderFns } from "./NavbarCollections.vue?vue&type=template&id=aa47cbde&scoped=true&"
import script from "./NavbarCollections.vue?vue&type=script&lang=js&"
export * from "./NavbarCollections.vue?vue&type=script&lang=js&"
import style0 from "./NavbarCollections.vue?vue&type=style&index=0&id=aa47cbde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa47cbde",
  null
  
)

export default component.exports